import { Select } from "antd";
import { City, State } from "country-state-city";
import React from "react";
const { Option } = Select;

function LocationDropDown({
  setSelectedState,
  setSelectedDistrict,
  setSelectedCity,
  selectedState,
  selectedDistrict,
  setSelectedLocations,
  selectedCity
}) {
  // Get Indian states, districts, and cities
  const indiaCode = "IN";
  const states = State.getStatesOfCountry(indiaCode);
  const districts = selectedState
    ? City.getCitiesOfState(indiaCode, selectedState)
    : [];
  const cities = selectedDistrict
    ? City.getCitiesOfState(indiaCode, selectedState).filter(
        (city) => city.name !== selectedDistrict
      )
    : [];

  const handleStateChange = (value) => {
    setSelectedState(value);
    setSelectedDistrict(null);
    setSelectedCity(null);
    updateSelectedLocations(value, null, null);
  };

  const handleDistrictChange = (value) => {
    setSelectedDistrict(value);
    setSelectedCity(null);
    updateSelectedLocations(selectedState, value, null);
  };

  const handleCityChange = (value) => {
    setSelectedCity(value);
    updateSelectedLocations(selectedState, selectedDistrict, value);
  };

  const updateSelectedLocations = (state, district, city) => {
    setSelectedLocations({
      state: state ? State.getStateByCodeAndCountry(state, indiaCode)?.name : null,
      district: district,
      city: city
    });
  };

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      <Select
        placeholder="Select State"
        value={selectedState}
        onChange={handleStateChange}
      >
        {states.map((state) => (
          <Option key={state.isoCode} value={state.isoCode}>
            {state.name}
          </Option>
        ))}
      </Select>
      <Select
        placeholder="Select District"
        value={selectedDistrict}
        onChange={handleDistrictChange}
        disabled={!selectedState}
      >
        {districts.map((district) => (
          <Option key={district.name} value={district.name}>
            {district.name}
          </Option>
        ))}
      </Select>
      <Select
        placeholder="Select City"
        value={selectedCity}
        onChange={handleCityChange}
        disabled={!selectedDistrict}
      >
        {cities.map((city) => (
          <Option key={city.name} value={city.name}>
            {city.name}
          </Option>
        ))}
      </Select>
    </div>
  );
}

export default LocationDropDown;